function mergeCartIconBubbleFromSectionHtml(htmlString, rootSelector) {
	const cartLink = document.getElementById("cart-icon-bubble");
	if (!cartLink || !htmlString) return false;
	const doc = new DOMParser().parseFromString(htmlString, "text/html");
	const root = rootSelector ? doc.querySelector(rootSelector) : doc.body;
	if (!root) return false;
	const newBubble = root.querySelector(".cart-count-bubble");
	const oldBubble = cartLink.querySelector(".cart-count-bubble");
	if (!newBubble || !oldBubble) return false;
	oldBubble.outerHTML = newBubble.outerHTML;
	return true;
}

class CartRemoveButton extends HTMLElement {
	constructor() {
		super();

		this.addEventListener("click", (event) => {
			event.preventDefault();
			const cartItems =
				this.closest("cart-items") || this.closest("cart-drawer-items");
			cartItems.updateQuantity(this.dataset.index, 0);
		});
	}
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();
		this.lineItemStatusElement =
			document.getElementById("shopping-cart-line-item-status") ||
			document.getElementById("CartDrawer-LineItemStatus");

		const debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, ON_CHANGE_DEBOUNCE_TIMER);

		this.addEventListener("change", debouncedOnChange.bind(this));
		//this.addCloseButtonHandlers();
	}

	cartUpdateUnsubscriber = undefined;


	addCloseButtonHandlers() {
		const closeButton = document.querySelector("#cart_note-close");
		const applyButton = document.querySelector("#apply_button");

		if (closeButton) {
			closeButton.addEventListener("click", function () {
				document.getElementById("Details-CartDrawer").removeAttribute("open");
			});
		}
		if (applyButton) {
			applyButton.addEventListener("click", function () {
				document.getElementById("Details-CartDrawer").removeAttribute("open");
			});
		}
	}

	connectedCallback() {
		this.cartUpdateUnsubscriber = subscribe(
			PUB_SUB_EVENTS.cartUpdate,
			(event) => {
				if (event.source === "cart-items") {
					return;
				}
				this.onCartUpdate();
			}
		);
	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber();
		}
	}

	onChange(event) {
		this.updateQuantity(
			event.target.dataset.index,
			event.target.value,
			document.activeElement.getAttribute("name")
		);
	}

	onCartUpdate() {
		fetch(`${routes.cart_url}?section_id=main-cart`)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				const sourceQty = html.querySelector("cart-items");
				this.innerHTML = sourceQty.innerHTML;
			})
			.catch((e) => {
				console.error(e);
			});
	}

	getSectionsToRender() {
		return [
			{
				id: "main-cart-items",
				section: document.getElementById("main-cart-items").dataset.id,
				selector: ".js-contents",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
			{
				id: "cart-live-region-text",
				section: "cart-live-region-text",
				selector: ".shopify-section",
			},
			{
				id: "main-cart-footer",
				section: document.getElementById("main-cart-footer").dataset.id,
				selector: ".js-contents-2",
			},
		];
	}

	updateQuantity(line, quantity, name) {
		this.enableLoading(line);
		this.querySelectorAll(".quantity__button").forEach((button) =>
			button.classList.add("disabled")
		);

		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});
		const items = document.querySelectorAll(".cart-item");

		fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				const quantityElement =
					document.getElementById(`Quantity-${line}`) ||
					document.getElementById(`Drawer-quantity-${line}`);

				if (parsedState.errors) {
					quantityElement.value = quantityElement.getAttribute("value");
					this.updateLiveRegions(line, parsedState.errors);

					// dispatch cart:error
          document.dispatchEvent(
						new CustomEvent("cart:error", {
							detail: {
								source: this.dataset.source,
							productVariantId: items[line - 1]?.dataset.variantId || line,
								errors: parsedState.errors,
								message: parsedState.errors,
							},
						})
					);

					return;
				}

				// dispatch line-item:change for the modified element
        document.dispatchEvent(
          new CustomEvent("line-item:change", {
            detail: {
							lineItem: parsedState.items[line - 1] || null,
							cart: parsedState,
							sectionId: this.dataset.source,
						},
          })
        );

				this.classList.toggle("is-empty", parsedState.item_count === 0);

				// dispatch cart:change for the entire basket
        document.dispatchEvent(
          new CustomEvent("cart:change", {
            detail: {
							cart: parsedState,
							sectionId: this.dataset.source,
						},
          })
        );

				const cartDrawerWrapper = document.querySelector("cart-drawer");
				const cartFooter = document.getElementById("main-cart-footer");

				if (cartFooter)
					cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
				if (cartDrawerWrapper)
					cartDrawerWrapper.classList.toggle(
						"is-empty",
						parsedState.item_count === 0
					);

				this.getSectionsToRender().forEach((section) => {
					const sectionHtml = parsedState.sections[section.section];
					if (
						section.section === "cart-icon-bubble" &&
						sectionHtml &&
						mergeCartIconBubbleFromSectionHtml(
							sectionHtml,
							section.selector
						)
					) {
						const cartLink = document.getElementById("cart-icon-bubble");
						if (cartLink && typeof parsedState.item_count === "number") {
							cartLink.classList.toggle(
								"header__cart--empt",
								parsedState.item_count < 1
							);
						}
						return;
					}
					const elementToReplace =
						document
							.getElementById(section.id)
							.querySelector(section.selector) ||
						document.getElementById(section.id);
					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector
					);
				});
				const updatedValue = parsedState.items[line - 1]
					? parsedState.items[line - 1].quantity
					: undefined;
				let message = "";
				if (
					items.length === parsedState.items.length &&
					updatedValue !== parseInt(quantityElement.value)
				) {
					if (typeof updatedValue === "undefined") {
						message = window.cartStrings.error;
					} else {
						message = window.cartStrings.quantityError.replace(
							"[quantity]",
							updatedValue
						);
					}
				}
				this.updateLiveRegions(line, message);

				const lineItem =
					document.getElementById(`CartItem-${line}`) ||
					document.getElementById(`CartDrawer-Item-${line}`);
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper
						? trapFocus(
								cartDrawerWrapper,
								lineItem.querySelector(`[name="${name}"]`)
						  )
						: lineItem.querySelector(`[name="${name}"]`).focus();
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper.querySelector(".drawer__inner-empty"),
						cartDrawerWrapper.querySelector("a")
					);
				} else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper,
						document.querySelector(".cart-item__name")
					);
				}
				publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
			})
			.catch(() => {
				this.querySelectorAll(".loading-overlay").forEach((overlay) =>
					overlay.classList.add("hidden")
				);
				this.querySelectorAll(".quantity__button").forEach((button) =>
					button.classList.remove("disabled")
				);
				const errors =
					document.getElementById("cart-errors") ||
					document.getElementById("CartDrawer-CartErrors");
				errors.textContent = window.cartStrings.error;

				// dispatch cart:error when fetch fail
        document.dispatchEvent(
					new CustomEvent("cart:error", {
						detail: {
							source: this.dataset.source,
							productVariantId: items[line - 1]?.dataset.variantId || line,
							errors: window.cartStrings.error,
							message: window.cartStrings.error,
						},
					})
				);
			})
			.finally(() => {
				this.querySelectorAll(".quantity__button").forEach((button) =>
					button.classList.remove("disabled")
				);
				this.disableLoading(line);
				this.addCloseButtonHandlers();
				
			});
	}

	updateLiveRegions(line, message) {
		const lineItemError =
			document.getElementById(`Line-item-error-${line}`) ||
			document.getElementById(`CartDrawer-LineItemError-${line}`);
		if (lineItemError)
			lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

		this.lineItemStatusElement.setAttribute("aria-hidden", true);

		const cartStatus =
			document.getElementById("cart-live-region-text") ||
			document.getElementById("CartDrawer-LiveRegionText");
		cartStatus.setAttribute("aria-hidden", false);

		setTimeout(() => {
			cartStatus.setAttribute("aria-hidden", true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.add("cart__items--disabled");

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
			overlay.classList.remove("hidden")
		);

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute("aria-hidden", false);
	}

	disableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.remove("cart__items--disabled");

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		);

		cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
		cartDrawerItemElements.forEach((overlay) =>
			overlay.classList.add("hidden")
		);
	}
}

customElements.define("cart-items", CartItems);

class CartNote extends HTMLElement {
	constructor() {
		super();
		this.spinnerIcon = this.querySelector(".cart__note-loading");
		this.successIcon = this.querySelector(".cart__note-success");
		this.textarea = this.querySelector("textarea");
		this.cartButtons = document.querySelector(".cart__ctas");
		this.drawerButtons = document.querySelector(".cart-drawer__buttons");

		this.textarea.addEventListener(
			"input",
			debounce((event) => {
				if (this.spinnerIcon) this.spinnerIcon.style.display = "flex";
				if (this.successIcon) this.successIcon.style.display = "none";
				if (this.cartButtons) this.cartButtons.style.pointerEvents = "none";
				if (this.cartButtons) this.cartButtons.style.opacity = "0.7";
				if (this.drawerButtons) this.drawerButtons.style.pointerEvents = "none";
				if (this.drawerButtons) this.drawerButtons.style.opacity = "0.7";

				const body = JSON.stringify({ note: event.target.value });

				fetch(`${routes.cart_update_url}`, {
					...fetchConfig(),
					...{ body },
				})
					.then((response) => {
						if (!response.ok) {
							throw new Error("Network response was not ok");
						}
						return response.json();
					})
					.then((data) => {
						if (this.successIcon) this.successIcon.style.display = "flex";
						setTimeout(() => {
							if (this.successIcon) this.successIcon.style.display = "none";
						}, 2000);
					})
					.catch((error) => {
						console.error("Something went wrong. ", error);
					})
					.finally(() => {
						if (this.spinnerIcon) this.spinnerIcon.style.display = "none";
						if (this.cartButtons) this.cartButtons.removeAttribute("style");
						if (this.drawerButtons) this.drawerButtons.removeAttribute("style");
					});
			}, ON_CHANGE_DEBOUNCE_TIMER)
		);
	}
}

if (!customElements.get("cart-note")) {
	customElements.define("cart-note", CartNote);
}
